import clsx from 'clsx';
import { Breadcrumbs } from '../../components/Breadcrumbs';
import { Skeleton } from '../../components/Skeleton';
import { SkeletonFields } from '../../components/SkeletonFields';
import { SkeletonRegion } from '../../components/SkeletonRegion';
import type { Crumb } from '../../layouts/section-trail';
import { ZONE_EDITOR_GRID, ZONE_MAP_HEIGHT } from './zone-editor-layout';

/** ZoneEditorPage before its zone, kinds and map key arrive: the header, the fields card and the map, in ZoneForm's grid. */
/** `breadcrumbs` are known before the zone loads, so they render for real rather than as a bar. */
export function ZoneEditorSkeleton({ breadcrumbs }: { breadcrumbs: Crumb[] }) {
  return (
    <SkeletonRegion label="Loading zone">
      <div className="mb-8 flex flex-col gap-2.5">
        <Breadcrumbs trail={breadcrumbs} />
        <Skeleton className="h-7 w-56 max-w-full" />
        <Skeleton className="h-4 w-72 max-w-full" />
      </div>
      <div className={ZONE_EDITOR_GRID}>
        <div className="rounded-lg border border-line bg-surface p-5">
          <SkeletonFields count={4} />
          <Skeleton className="mt-8 h-8 w-32" />
        </div>
        <Skeleton className={clsx('rounded-lg', ZONE_MAP_HEIGHT)} />
      </div>
    </SkeletonRegion>
  );
}
